<template>
  <section>
    <!-- <filter-component :filters="filters" :showEnd="true" @filter="applyFilters" :types="equipmentTypes" /> -->

    <b-tabs v-model="activeTab" type="is-toggle" style="padding:20px;">
      <b-tab-item :label="`All (${tips.length})`">
        <orders-table
          :data="tips"
          :isLoading="isLoading"
          @reloadOrders="getTips"
          :show-status="true"
        >
        </orders-table>
      </b-tab-item>
      <b-tab-item :label="`Maize (${maizeCrops.length})`">
        <orders-table
          :data="maizeCrops"
          :isLoading="isLoading"
          @reloadOrders="getTips"
          :show-status="true"
        >
        </orders-table>
      </b-tab-item>

      <b-tab-item :label="`Wheat (${wheatCrops.length})`">
        <orders-table
          :data="wheatCrops"
          :isLoading="isLoading"
          @reloadOrders="getTips"
          :show-status="true"
        >
        </orders-table>
      </b-tab-item>

      <b-tab-item :label="`Sugar Beans (${sugarBeansCrops.length})`">
        <orders-table
          :data="sugarBeansCrops"
          :isLoading="isLoading"
          @reloadOrders="getTips"
          :show-status="true"
        >
        </orders-table>
      </b-tab-item>

      <b-tab-item :label="`Soya Beans  (${soyaBeansCrops.length})`">
        <orders-table
          :data="soyaBeansCrops"
          :isLoading="isLoading"
          @reloadOrders="getTips"
        ></orders-table>
      </b-tab-item>
    </b-tabs>
  </section>
</template>
<script>
//todo: work on filtering croptipts and their names
// Work on Soil Tests
import OrdersTable from "@/components/CropManager/TipsTable";
import FilterComponent from "@/components/Shared/Filters";
import { mapActions, mapGetters } from "vuex";
import { mdy } from "@/helpers";
export default {
  name: "CropTips",
  components: {
    OrdersTable,
    FilterComponent,
    d: ["Maize", "Sorghum", "Wheat", "Tobbaco"]
  },

  computed: {
    ...mapGetters(["drivers"]),

    // filters() {
    //   return this.$store.getters.filters;
    // },
    // },
    maizeCrops() {
      return this.tips.filter(tip => tip.cropName == "Maize");
    },
    sorghumCrops() {
      return this.tips.filter(tip => tip.cropName == "Sorghum");
    },
    tobbacoCrops() {
      return this.tips.filter(tip => tip.cropName == "Tobbaco");
    },
    wheatCrops() {
      return this.tips.filter(tip => tip.cropName == "Wheat");
    },
    sugarBeansCrops() {
      return this.tips.filter(tip => tip.cropName == "Sugar Beans");
    },
    soyaBeansCrops() {
      return this.tips.filter(tip => tip.cropName == "Soya Beans");
    }
  },
  data() {
    return {
      tips: [],
      activeTab: 0,
      isLoading: false,
      filter: this.filters
    };
  },
  created() {
    this.getTips(this.filters);
  },
  methods: {
    ...mapActions(["getDrivers"]),
    getTips(filters = this.filters) {
      this.tips = [];
      this.isLoading = true;

      this.$store
        .dispatch("getTips", filters)
        .then(tips => {
          this.isLoading = false;
          this.tips = tips;
        })
        .catch(e => {
          console.log(`Exception when getting crop tips, e:${e}`);
          this.isLoading = false;
        });
    },
    applyFilters({
      start,
      end,
      mobile_number,
      name,
      requestNumber,
      deliveryCities,
      equipmentTypeId
    }) {
      end.setHours(24);
      const fromDate = mdy(start);
      const toDate = mdy(end);
      this.$store.commit("setFilters", {
        fromDate,
        toDate,
        mobile_number,
        name,
        requestNumber,
        deliveryCities,
        equipmentTypeId
      });
      this.getTips();
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/CropManager/ViewCrop.vue